'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { EventService } from '@/shared/lib/event-service';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const FavoriteItemsButton = ({ media, ...props }: Props) => {
    const t = useTranslations();

    const handleShowFavorites = async () => {
        EventService.trigger('account:favorite-items:view-detail');
    };

    return (
        <Layout
            element="button"
            type="button"
            data-testid="favorite-items-button"
            aria-label={t('NAVBAR.FAVORITES')}
            onClick={handleShowFavorites}
            media={{
                ...media,
                initial: {
                    flexShrink: 0,
                    width: '2rem',
                    height: '2rem',
                    cursor: 'pointer',
                    ...media?.initial,
                },
            }}
            {...props}
        >
            <Icon name="heart" width={28} height={28} data-testid="favorite-items-button-icon" />
        </Layout>
    );
};
